import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const badge = css`
  display: flex;
  padding: 0px 12px;
  justify-content: space-between;
  border-radius: 3px;
  margin-bottom: 12px;
  align-items: center;
  background-color: ${colors.gray.lightest};
`;

export const title = css`
  font-size: ${fonts.size.medium};
`;

export const buttonFAQ = css`
  text-decoration: none;
`;

export const simpleText = css`
  font-size: ${fonts.size.smallest};
  margin-right: 12px;
`;

export const grayText = css`
  color: ${colors.gray.dark};
`;

export const icon = css`
  color: ${colors.gray.dark};
  text-align: center;
  vertical-align: middle;
  margin-right: 12px;
`;

export const paddingTop = css`
  margin: 20px 0 10px;
`;
